import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-black border-t border-white/10 pt-20 pb-10" data-id="element-370" data-mp="ep26ghym9wd4">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-371" data-mp="alnohlr4b5x1">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-372" data-mp="ao9xlptnpthd">
          {/* Company Info */}
          <div className="flex flex-col gap-6" data-id="element-373" data-mp="nzks6bjao2q">
            <Link to="/" className="flex items-center gap-2" data-id="element-374" data-mp="orf7dteafrf">
              <img src="https://cdn.magicpatterns.com/uploads/tEKY1KVFn8NPQae4HonbJW/9fea8157-abe6-4116-8e53-72149f139631.png" alt="Design Flow Digitals" className="w-10 h-10 object-contain" data-id="element-375" data-mp="3s2x43c6tcx30" />
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-376" data-mp="3j3tlsafh0lpk">
                Design Flow Digitals
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-377" data-mp="3939kx8vv5j7v">
              Premium Shopify development company specializing in themes, apps
              and high-converting ecommerce stores.
            </p>
            <div className="text-sm text-gray-500" data-id="element-378" data-mp="2p4v17b82cq90">
              <p data-id="element-379" data-mp="2p5o39yw2urkt">Part of Pankaj Maurya LLC</p>
              <p data-id="element-380" data-mp="2bdhiu0lw5yfk">67 Wigley Loop</p>
              <p data-id="element-381" data-mp="2babuinl370kw">Whitwell, TN 37397</p>
              <p data-id="element-382" data-mp="2gazw236xyztd">United States</p>
            </div>
            <a href="mailto:support@designflowdigitals.com" className="text-gradient-gold font-medium text-sm hover:opacity-80 transition-opacity" data-id="element-383" data-mp="2gbrh4k2wxf5e">
              support@designflowdigitals.com
            </a>
          </div>

          {/* Company Links */}
          <div data-id="element-384" data-mp="2u2o6m21jlg88">
            <h3 className="text-white font-semibold mb-6" data-id="element-385" data-mp="2u50pqij1dwmv">Company</h3>
            <ul className="flex flex-col gap-4" data-id="element-386" data-mp="2z0fxqtud4ybd">
              <li data-id="element-387" data-mp="1io0v3g97v5po">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-388" data-mp="1inho2ul3u1qf">
                  About Us
                </Link>
              </li>
              <li data-id="element-389" data-mp="13jg1h4m7r7zc">
                <Link to="/team" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-390" data-mp="13jy72rurmyjx">
                  Meet the Team
                </Link>
              </li>
              <li data-id="element-391" data-mp="ptcluwhuaciv">
                <Link to="/portfolio" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-392" data-mp="pu4f40nyry5z">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-393" data-mp="ftln2im8xbcz">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-394" data-mp="fx9gzivlrzs8">
                  Contact
                </Link>
              </li>
              <li data-id="element-395" data-mp="267kvxrlfatdm">
                <Link to="/support" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-396" data-mp="267ukrbuqeuhq">
                  Support Center
                </Link>
              </li>
            </ul>
          </div>

          {/* Shopify Apps */}
          <div data-id="element-397" data-mp="2dqk8peedpmo0">
            <h3 className="text-white font-semibold mb-6" data-id="element-398" data-mp="2dq27e3cv0i98">Shopify Apps</h3>
            <ul className="flex flex-col gap-4" data-id="element-399" data-mp="2ihageyaa21lv">
              <li data-id="element-400" data-mp="2iilv3t59gtrr">
                <Link to="/apps" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-401" data-mp="2ik6eqnq1esau">
                  All Apps
                </Link>
              </li>
              <li data-id="element-402" data-mp="1urzqkbugtrmi">
                <Link to="/seo-suite" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-403" data-mp="1urg7uswzqz7f">
                  SEO Suite App
                </Link>
              </li>
              <li data-id="element-404" data-mp="23u8yqv29h8wq">
                <Link to="/ai-photoshoot" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-405" data-mp="23ql41sl2yggf">
                  AI Photoshoot App
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-406" data-mp="3dsqr853d8xh7">
            <h3 className="text-white font-semibold mb-6" data-id="element-407" data-mp="38s2ssyct5ecy">Services</h3>
            <ul className="flex flex-col gap-4" data-id="element-408" data-mp="38txguljdlml9">
              <li data-id="element-409" data-mp="3npd9qn87zcg2">
                <Link to="/services/store-development" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-410" data-mp="3npv93sq6i6s7">
                  Store Development
                </Link>
              </li>
              <li data-id="element-411" data-mp="3rqyj3yljp8li">
                <Link to="/services/theme-development" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-412" data-mp="3rrgpho1x9375">
                  Theme Development
                </Link>
              </li>
              <li data-id="element-413" data-mp="5dgjohgpj021">
                <Link to="/services/app-development" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-414" data-mp="jalx52ir317b">
                  App Development
                </Link>
              </li>
              <li data-id="element-415" data-mp="xy3s396ighgj">
                <Link to="/services/conversion-optimization" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-416" data-mp="xvhk58fpjzxs">
                  Conversion Optimization
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-417" data-mp="txtlpvet3p15">
          <p className="text-gray-500 text-sm" data-id="element-418" data-mp="jxjcsmzt13rs">
            &copy; {currentYear} Design Flow Digitals. All rights reserved.
          </p>
          <div className="flex items-center gap-6" data-id="element-419" data-mp="67pihp5j5rao">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-420" data-mp="a7qbcetdm519">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-421" data-mp="171w5gs8xyms">
              Terms of Service
            </Link>
            <Link to="/refund-policy" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-422" data-mp="1y5sfblmewsfc">
              Refund Policy
            </Link>
            <Link to="/cookies-policy" className="text-gray-500 hover:text-white transition-colors text-sm" data-id="element-423" data-mp="1u1t5tmzjutvh">
              Cookies Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}